import React, { PropTypes } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';
import '../../styles/ConfirmationModal';

let ConfirmationModal = React.createClass({
	displayName: 'ConfirmationModal',

	propTypes: {
		body: PropTypes.node.isRequired,
		cancelButtonStyle: PropTypes.string,
		cancelButtonText: PropTypes.string,
		confirmationButtonStyle: PropTypes.string,
		confirmationButtonText: PropTypes.string,
		imageUrl: PropTypes.string,
		isProcessing: PropTypes.bool,
		onCancel: PropTypes.func.isRequired,
		onConfirm: PropTypes.func.isRequired,
		shouldShow: PropTypes.bool,
		title: PropTypes.string.isRequired
	},

	render: function() {
		return (
			<Modal className="confirmation-modal" onHide={ this.props.onCancel } show={ this.props.shouldShow }>
				<Modal.Header>
					<img src={ this.props.imageUrl ? this.props.imageUrl : '/images/alert.png' } />
					<div className="modal-title">
						{ this.props.title }
					</div>
				</Modal.Header>
				<Modal.Body>
					{ this.props.body }
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={ this.props.onCancel }
						className="cancel btn-lg"
						bsStyle={ this.props.cancelButtonStyle }
						disabled={ this.props.isProcessing }
					>
						<i className="glyphicon glyphicon-remove" />{' '}
						{ this.props.cancelButtonText ? this.props.cancelButtonText : 'Cancel' }
					</Button>
					<Button
						bsStyle={ this.props.confirmationButtonStyle }
						className="confirm btn-lg"
						onClick={ this.props.onConfirm }
						disabled={ this.props.isProcessing }
					>
						<span>
							{
								this.props.isProcessing ? (
									<LoadingSpinner />
								) : (
									<i className="glyphicon glyphicon-ok" />
								)
							}
							{' '} { this.props.confirmationButtonText }
						</span>
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
});

module.exports = ConfirmationModal;



// WEBPACK FOOTER //
// ./frontend/a2i/js/components/ConfirmationModal.jsx